import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet } from '_zari/core'

import { CodigosTransaccionesConstant } from 'constants/index'

import { IdGen } from 'utils'

import * as RequerimientoService from 'services/requerimiento.service'

import MainForm from './mainForm'

const RequerimientoNuevoActualizar = ({ match }) => {
  const __zariContext = React.useContext(ZariContext)

  const [__keyMainForm, setKeyMainForm] = React.useState(null)

  const editarDataRef = React.useRef({})

  const portletBreadcrumbs = React.useMemo(() => {
    if (match.params.id) {
      return [
        { name: 'Requerimientos', path: `/${CodigosTransaccionesConstant.REQUERIMIENTOS_LISTA}` },
        { name: 'Editar' }
      ]
    }
    return [
      { name: 'Requerimientos', path: `/${CodigosTransaccionesConstant.REQUERIMIENTOS_LISTA}` },
      { name: 'Nuevo' }
    ]
  }, [match.params.id])

  React.useEffect(() => {
    if (match.params.id) {
      RequerimientoService.obtenerxIdAsEdicion(match.params.id)
        .then(({ data }) => {
          editarDataRef.current = data
          setKeyMainForm(IdGen.newId())
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    } else {
      setKeyMainForm(IdGen.newId())
    }
  }, [match.params, __zariContext])

  return (
    <Portlet>
      <Portlet.Header title='Requerimientos' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        {__keyMainForm && <MainForm key={__keyMainForm} editarData={editarDataRef.current} />}
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(RequerimientoNuevoActualizar)
